<script>
import vSelect from 'vue-select'
export default {
  data () {
    return {
      dados: null,
      optionsFilter: [],
      timerFiltro: 7
    }
  },
  components: { vSelect },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('model', newValue)
      }
    }
  },
  methods: {
  },
  props: {
    value: {
      type: Object,
      default: null,
      required: false
    },
    input: {
      type: Function,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    texto: {
      type: String,
      required: true
    },
    vazio: {
      type: String,
      required: false
    },
    filterable: {
      type: Boolean,
      required: false,
      default: true
    },
    funcao: {
      type: Function,
      required: false
    }
  },
  watch: {
    options: function () {
      this.optionsFilter = this.options
    }
  }
}
</script>
<template>
  <div>
    <v-select :on-search="funcao" v-model="model" @input="input" :options="optionsFilter" :placeholder="texto" :filterable="false">
      <span slot="no-options">
        {{vazio}}
      </span>
    </v-select>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// search-select-function.vue?f4685956